// Shows the product price plus the EMB (embroidery) fee while the "Customize me" tab is selected,
// multiplied by the selected quantity, minus a quantity-tier discount. Any other tab shows the normal product price.
(() => {
  const EMB_FEE_PRICE = 400; // $4.00 in cents (EMB fee variant 47115290411200)

  // Quantity discount tiers for "Customize me": [minimum quantity, discount %]. Highest matching tier wins.
  const QUANTITY_DISCOUNTS = [
    [250, 50],
    [100, 45],
    [50, 40],
    [25, 35],
    [12, 30],
    [6, 10],
    [1, 0],
  ];

  function discountFor(quantity) {
    const tier = QUANTITY_DISCOUNTS.find(([min]) => quantity >= min);
    return tier ? tier[1] : 0;
  }

  function formatWithDelimiters(cents, decimals, thousands, decimal) {
    const [whole, fraction] = (cents / 100).toFixed(decimals).split('.');
    return whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (fraction ? decimal + fraction : '');
  }

  function formatMoney(cents, format) {
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals':
          return formatWithDelimiters(cents, 0, ',', '.');
        case 'amount_with_comma_separator':
          return formatWithDelimiters(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return formatWithDelimiters(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator':
          return formatWithDelimiters(cents, 2, "'", '.');
        default:
          return formatWithDelimiters(cents, 2, ',', '.');
      }
    });
  }

  function setPrice(element, html) {
    if (!element) return;
    if (element.dataset.originalHtml === undefined) element.dataset.originalHtml = element.innerHTML;
    const next = html === null ? element.dataset.originalHtml : html;
    if (element.innerHTML !== next) element.innerHTML = next;
  }

  function updatePrice(wrapper) {
    const sectionId = wrapper.dataset.sectionId;
    const section = document.getElementById(`MainProduct-${sectionId}`) || document;
    const activeTab = section.querySelector('.quantity-tab li.current');
    const isCustomize = activeTab && activeTab.dataset.tab === 'customize-me';
    const embPrice = EMB_FEE_PRICE;

    const priceEl = wrapper.querySelector('.price[data-price]');
    if (!priceEl) return;

    const regular = priceEl.dataset.priceBreaks === 'true' ? null : priceEl.querySelector('.price__regular .price-item--regular');
    const sale = priceEl.querySelector('.price__sale .price-item--sale');
    const compare = priceEl.querySelector('.price__sale s.price-item--regular');

    if (!isCustomize || !embPrice) {
      [regular, sale, compare].forEach((element) => setPrice(element, null));
      return;
    }

    const quantityInput = document.getElementById(`Quantity-${sectionId}`);
    const quantity = Math.max(parseInt(quantityInput && quantityInput.value, 10) || 1, 1);
    const format = wrapper.dataset.moneyFormat || '${{amount}}';
    const subtotal = (Number(priceEl.dataset.price) + embPrice) * quantity;
    const price = Math.round(subtotal * (1 - discountFor(quantity) / 100));
    const comparePrice = Number(priceEl.dataset.comparePrice) || 0;

    setPrice(regular, formatMoney(price, format));
    setPrice(sale, formatMoney(price, format));
    if (comparePrice) setPrice(compare, formatMoney((comparePrice + embPrice) * quantity, format));
  }

  function wrapperFor(element) {
    const section = element.closest('[id^="MainProduct-"]');
    return section ? section.querySelector('[data-emb-fee-price]') : null;
  }

  function init() {
    document.querySelectorAll('[data-emb-fee-price]').forEach((wrapper) => {
      updatePrice(wrapper);
      // Variant changes replace the wrapper's contents (global.js), so re-apply afterwards.
      new MutationObserver(() => updatePrice(wrapper)).observe(wrapper, { childList: true });
    });

    document.addEventListener('click', (event) => {
      const tab = event.target.closest('.quantity-tab li');
      const wrapper = tab && wrapperFor(tab);
      // Defer so the tab's "current" class (set in custom.js) is applied first.
      if (wrapper) setTimeout(() => updatePrice(wrapper));
    });

    ['change', 'input'].forEach((type) =>
      document.addEventListener(type, (event) => {
        if (!event.target.matches || !event.target.matches('.quantity__input')) return;
        const wrapper = wrapperFor(event.target);
        if (wrapper) updatePrice(wrapper);
      })
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
